import React, { useState } from "react";
import Layout from "../components/Layout";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { toast } from "react-toastify";

import "../assets/css/Registerpage.scss";

const Registerpage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");
  const [loading, setLoading] = useState(false);
  const auth = getAuth();
  const navigate = useNavigate();

  const register = async () => {
    try {
      setLoading(true);
      const result = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      setLoading(false);
      setEmail("");
      setPassword("");
      setCpassword("");
      toast.success("Registration Success");
    } catch (error) {
      setLoading(false);
      toast.error("Registration Fail");
    }
  };

  return (
    <Layout loading={loading}>
      <div className="register_container col-md-6">
        <div className="register_section">
          <h4>Register</h4>
          <hr />
          <input
            type="text"
            className="form-control input_field"
            placeholder="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <input
            type="password"
            className="form-control input_field"
            placeholder="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <input
            type="text"
            className="form-control input_field"
            placeholder="confirm password"
            value={cpassword}
            onChange={(e) => {
              setCpassword(e.target.value);
            }}
          />
          <div className="register_button_section">
            <button className="btn btn-success" onClick={register}>
              Register
            </button>
            <Link to="/login">Existing User? Login</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Registerpage;
